<script>
    import {onMount} from 'svelte';
    import AuthService from '../services/auth.service';

    export let user, params;

    onMount(async () => {
        if (!user || !user.id) AuthService.logout();
    });
</script>
<main class="pt-5 text-center">
    {#if user && user.id}
        <h1 class="text-primary">Welcome, {user.name}</h1>
        <p id="select-text" class="pt-3">
            Please select a report at the top menu.
        </p>
    {/if}
</main>

<style>
    #select-text{
        font-size: x-large;
        color: #666;
    }
</style>
